import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Header from './Headers';
import MetaTags from 'react-meta-tags';
import ReactGA from 'react-ga';
import Footer from '../footer';


@inject('store')
@observer
class Aristo extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.store.homeType(false);
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/aristo');
    }

    render() {
        return (
            <div>
                <MetaTags>
                    <title>Moratorium</title>
                    <meta name="description" content="Some description."/>
                    <meta property="og:title" content="MyApp"/>
                    <meta property="og:image" content="path/to/image.jpg"/>
                </MetaTags>
                <Header/>
                <section className="banner_text headerbg">
                    <div className="container">
                        <div className="aboutusbanner full-w text-center ">
                            <h1 className="full-w tex-center whitecolor fz-20">Moratorium and Loan Restructure
                                Policy</h1>

                            <br/>
                        </div>
                    </div>
                </section>
                <section className="mainSec">
                    <div className="container">

                        <div className="row">

                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 morotorium-rep-css">
                                <img src={require('../images/logo.png')} alt='' width="200" height="260"
                                     className='img-fluid '/>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 morotorium-rep-css-ss">
                                <img src={require('../images/aristo_logo.png')} alt=''
                                     className='img-fluid revfin-capital'/>
                            </div>
                        </div>

                        <div className="revcontc">
                            <h1 className="full-w tex-center whitecolor fz-20"
                                style={{'margin-bottom': '30px', 'color': '#ffa052', 'text-align': 'center'}}>Revfin
                                Capital (Aristo Securities Private Limited)</h1>

                            <h5 className="color_main text-left mgt-20">1. BACKGROUND</h5>
                            <p>Aristo Securities Private Limited (hereinafter referred to as “Company”) is a Private
                                Limited Company incorporated under Companies Act, 1956. Aristo Securities Private
                                Limited is a Non-Banking Finance Company (NBFC) regulated & supervised by Reserve Bank
                                of India. The Company operates under the trademark – Revfin Capital. The Company employs
                                the services of its partner Revfin Services Private Limited (hereinafter referred to as
                                “Revfin”) for lead generation, borrower sourcing and loan application processing.
                                <br/>
                                <br/>
                                In view of recent stress in financial and social conditions caused by second wave of
                                Covid-19 (CORONA Virus), every government agency is taking measures to curb the negative
                                impact of pandemic.
                                <br/>
                                <br/>
                                Reserve Bank of India (RBI) has taken multiple measures on May 5, 2021 to mitigate the
                                negative effect of second wave of pandemic, to revive growth and to preserve financial
                                stability.
                                <br/>
                                <br/>
                                RBI vide its Circular RBI/2021-22/31 DOR.STR.REC.11/21.04.048/2021-22, dated May 5, 2021
                                announced Resolution Framework 2.0 for COVID Related Stressed Assets of Individuals,
                                Small Businesses and MSMEs.</p>
                            <h5 className="color_main text-left mgt-20">2. POLICY STATEMENT</h5>
                            <p>
                                Aristo Securities will offer a moratorium and restructure on loans to all eligible
                                customers as per the circular issued by RBI.
                                <br></br><br></br></p>

                            <h5 className="color_main text-left mgt-20">3. PURPOSE OF THE POLICY</h5>
                            <p>
                                As announced by RBI’s Circular RBI/2021-22/31 DOR.STR.REC.11/21.04.048/2021-22, dated
                                May 5, 2021, the intensification of COVID-19 disruptions has imparted priority to
                                relaxing repayment pressures and improving access to working capital by mitigating the
                                burden of debt servicing, prevent the transmission of financial stress to the real
                                economy, and ensure the continuity of viable businesses and households.
                                <br></br><br></br>

                                Through this document, the Company has proposed extending moratorium to customers who
                                are facing financial difficulty due to this pandemic in line with afore mentioned RBI’s
                                Circulars on “Resolution Framework 2.0 for COVID Related Stressed Assets of Individuals,
                                Small Businesses and MSMEs. </p>


                            <h5 className="color_main text-left mgt-20">4. EFFECTIVE DATE AND AMENDMENTS</h5>
                            <p>This policy is effective from 10th May’21. The policy may get be amended from time to
                                time as per RBI circular/company policy.
                            </p>

                            <h5 className="color_main text-left mgt-20">5. POLICY APPLICABILITY</h5>
                            <p>
                                In view of the lockdown and continuing disruption on account of second wave of COVID-19,
                                Individuals who have availed of personal loans (as defined in the Circular
                                DBR.No.BP.BC.99/08.13.100/2017-18 dated January 4, 2018 on “XBRL Returns – Harmonization
                                of Banking Statistics”), excluding the credit facilities provided by lending
                                institutions to their own personnel/staff are permitted to extend the moratorium by
                                another 5 months i.e. from May 1, 2021 to September 30, 2021 on payment of all
                                instalments in respect of term loans Accordingly, the repayment schedule for such loans
                                as also the residual tenor, will be shifted across the board. Interest shall continue to
                                accrue on the outstanding portion of the term loans during the moratorium period.
                                <br></br><br></br>
                                The above measures shall be contingent on the lending institutions satisfying themselves
                                that the same is necessitated on account of the economic fallout from COVID-19. Further,
                                accounts provided relief under these instructions shall be subject to subsequent
                                supervisory review with regard to their justifiability on account of the economic
                                fallout from COVID-19.

                            </p>
                            <h5 className="color_main text-left mgt-20">6. CUSTOMER IDENTIFICATION</h5>
                            <p>
                                Granting of Moratorium/Restructure shall be at the sole discretion of the Company. The
                                following borrowers will be eligible for a moratorium/restructure based on RBI
                                guidelines:
                                <br></br><br></br>
                                <ul>
                                    <li style={{'list-style': 'initial'}}>Individuals who have availed of loans and
                                        advances for business purposes and to whom the lending institutions have
                                        aggregate exposure of not more than Rs.25 crore as on March 31, 2021
                                    </li>

                                    <li style={{'list-style': 'initial'}}>Borrowers with loans outstanding as of March
                                        31, 2021 and classNameified as Standard (i.e., up to four instalments overdue)
                                        as on Mar 31, 2021
                                    </li>

                                    <li style={{'list-style': 'initial'}}>Moratorium will be offered for installments
                                        falling due between May 1, 2021 and September 30, 2021.
                                    </li>
                                </ul>
                            </p>

                            <h5 className="color_main text-left mgt-20">7. MORATORIUM / LOAN RESTRUCTURING PERIOD AND
                                METHODOLOGY</h5>
                            <p>
                                As per RBI circular dated 5 May 2021, NBFCs are permitted to offer moratorium & Loan
                                Restructuring to its borrowers. The Company may, at its sole discretion, extend the
                                moratorium/deferment of EMIs to borrowers on need based, who have been impacted by the
                                COVID – 19 situations.
                                <br></br><br></br>
                                Customers who are requesting for moratorium/Restructuring shall be informed about
                                financial implications of such extension of moratorium/Restructuring including the
                                applicable interest on such action.
                                <br></br><br></br>
                                <ul>
                                    <li style={{'list-style': 'initial'}}>
                                        The moratorium period may be a maximum of two years and shall come into force
                                        immediately upon implementation of the resolution plan. The extension of the
                                        residual tenor of the loan facilities may also be granted to customers, with or
                                        without payment moratorium. The overall cap on extension of residual tenor,
                                        inclusive of moratorium period if any permitted, shall be two years.
                                    </li>
                                    <li style={{'list-style': 'initial'}}>
                                        Interest amount of the EMI deferred would be charged as one time Moratorium
                                        amount and will be added in a separate code “Moratorium Amount” or Interest
                                        amount of the EMI deferred would be capitalized in the loan.
                                    </li>
                                    <li style={{'list-style': 'initial'}}>Company would continue to present EMI dues as
                                        per normal process during this time for all its customers, unless such customers
                                        specifically requested for moratorium/Loan Restructuring after taking cognizance
                                        of the additional financial implication on their loan because of the moratorium/
                                        Restructuring.
                                    </li>
                                    <li style={{'list-style': 'initial'}}>Moratorium/deferment of EMIs would be done on
                                        monthly basis at a time of EMI’s falling due during 1st May 2021 to 30 th
                                        September 2021, decision for the same will be taken by the company on a
                                        case-to-case basis.
                                    </li>
                                    <li style={{'list-style': 'initial'}}>In case customers neither paid the EMI amount
                                        nor requested for moratorium in writing/requesting to the Company this time,
                                        such customers would be provided moratorium by the Company for that particular
                                        month only. The customers will be required to request verbally or in writing, if
                                        they need moratorium for all the remaining months of extended moratorium period.
                                    </li>
                                    <li style={{'list-style': 'initial'}}>Loan Restructuring would be given to those
                                        customers who would give the consent to the company in writing or over a call.
                                    </li>
                                    <li style={{'list-style': 'initial'}}>Principal of EMI amount (for which Moratorium
                                        has been given) would be added in existing Loan’s Principal outstanding amount
                                        wherein EMI interest would be capitalized. Or a new loan will be booked with the
                                        Total Outstanding amount of existing loan with the same terms & conditions
                                        (except Processing fee, EMI Amount & Loan Tenure).
                                    </li>
                                    <li style={{'list-style': 'initial'}}>Consent would be taken from the customer for
                                        revised “Terms & Conditions” of existing /new loan through SMS/Company’s
                                        APP/Web.
                                    </li>
                                    <li style={{'list-style': 'initial'}}>Terms & Conditions of new loan will be taken
                                        from all such customers through SMS/Company’s APP.
                                    </li>
                                    <li style={{'list-style': 'initial'}}>Moratorium option can also be given to such
                                        customers in new restructured loans based on customer’ request in case of a new
                                        loan is getting booked.
                                    </li>
                                </ul>
                                <br></br><br></br>
                            </p>
                            <h5 className="color_main text-left mgt-20">8. ASSET CLASSIFICATION AND PROVISIONING</h5>
                            <p>
                                The subsequent asset classification for such exposures will be governed by the criteria
                                laid out in the Master Circular - Prudential norms on Income Recognition, Asset
                                Classification and Provisioning pertaining to Advances dated July 1, 2015 or other
                                relevant instructions as applicable to specific category of lending institutions
                                (“extant IRAC norms”).

                                <br/>
                                <br/>
                                In respect of accounts classified as standard as on March 31, 2021, even if overdue, the
                                moratorium period, wherever granted in respect of term loans, shall be excluded by the
                                lending institutions from the number of days past-due for the purpose of asset
                                classification under the IRAC norms. The asset classification for such accounts shall be
                                determined on the basis of revised repayment schedule.
                                <br/>
                                <br/>
                                The customers acquired in the month of March 2021 are also being offered the benefit of
                                Moratorium as such customers are also getting impacted due to second wave of Covid-19
                                pandemic and the resulted economic lockdown. The benefit of moratorium, asset
                                classification benefit and consumer bureau reporting would also apply to these cases as
                                well.
                                <br/>
                                <br/>
                                All other provisions of RBI circular dated May 5, 2021 will remain applicable mutatis
                                mutandis.
                            </p>


                            <h5 className="color_main text-left mgt-20">9. POLICY PUBLICATION AND DISPLAY ON
                                WEBSITE</h5>
                            <p>The Board approved amended Moratorium Policy will be hosted on a webpage for borrowers of
                                the Company on Revfin’s website as per the instruction mentioned in RBI’s Circular.
                            </p>

                            <h5 className="color_main text-left mgt-20">10. DISCLOSURES AND CREDIT REPORTING</h5>
                            <p>Disclosures and credit reporting will be as per the format stipulated in RBI’s Circular
                                dated May 5, 2021. The credit history of the borrowers shall be governed by the
                                respective policies of the credit information companies as applicable to accounts that
                                are restructured.

                            </p>

                        </div>
                    </div>

                </section>


                <Footer/>
            </div>
        )
    }
}


export default Aristo



// WEBPACK FOOTER //
// ./src/components/aristo.js